<nav class="navbar navbar-inverse navbar-fixed-top constructor-header">
    <ng-content select="[onboarding]"></ng-content>
    <div class="container-fluid">
        <ng-content select="[start]"></ng-content>

        <ng-content select="[end]"></ng-content>
    </div>
</nav>
